import React from "react";
import Select from "react-select";
import { FiUpload } from "react-icons/fi";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import {
  getMeetingAttachmentName,
  getMeetingAttachmentSizeLabel,
} from "./meetingUtils";

function MeetingFormFields({
  formData,
  errors,
  userOptions,
  selectedAttendees,
  onInputChange,
  onAttendeesChange,
  fileInputRef,
  attachments,
  isAttachmentPopupOpen,
  onUploadClick,
  onFileInputChange,
  onToggleAttachmentPopup,
  onCloseAttachmentPopup,
  onDeleteAttachment,
}) {
  return (
    <div className="new-data-form">
      <div className="form-group">
        <label htmlFor="title">
          Title <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            id="title"
            name="title"
            type="text"
            value={formData.title}
            onChange={onInputChange}
            placeholder="Enter meeting title"
          />
        </div>
        {errors.title && <div className="error-message">{errors.title}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="date">
          Meeting Date <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            id="date"
            name="date"
            type="date"
            value={formData.date}
            onChange={onInputChange}
          />
        </div>
        {errors.date && <div className="error-message">{errors.date}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="location">Location</label>
        <div className="input-group">
          <input
            id="location"
            name="location"
            type="text"
            value={formData.location}
            onChange={onInputChange}
            placeholder="Enter meeting location"
          />
        </div>
        {errors.location && (
          <div className="error-message">{errors.location}</div>
        )}
      </div>

      <div className="form-group-select">
        <label htmlFor="attendee_ids">Attendees</label>
        <Select
          inputId="attendee_ids"
          options={userOptions}
          value={selectedAttendees}
          onChange={onAttendeesChange}
          placeholder="Select attendees"
          className="select-input meeting-select-input"
          isMulti
          isSearchable
          closeMenuOnSelect={false}
        />
        {errors.attendee_ids && (
          <div className="error-message">{errors.attendee_ids}</div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="agenda">Agenda</label>
        <div className="input-group">
          <textarea
            id="agenda"
            name="agenda"
            value={formData.agenda}
            onChange={onInputChange}
            placeholder="Enter meeting agenda"
            rows={4}
          />
        </div>
        {errors.agenda && <div className="error-message">{errors.agenda}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="minutes">Minutes</label>
        <div className="input-group">
          <textarea
            id="minutes"
            name="minutes"
            value={formData.minutes}
            onChange={onInputChange}
            placeholder="Enter meeting minutes"
            rows={5}
          />
        </div>
        {errors.minutes && (
          <div className="error-message">{errors.minutes}</div>
        )}
      </div>

      <div className="form-group-attachments">
        <div className="form-group">
          <label htmlFor="meeting_attachments">Documents</label>
          <button
            type="button"
            className="challan-btn"
            onClick={onUploadClick}
          >
            <FiUpload /> Upload File
          </button>
          <input
            type="file"
            id="meeting_attachments"
            ref={fileInputRef}
            onChange={onFileInputChange}
            style={{ display: "none" }}
            multiple
          />
          {attachments.length > 0 && (
            <span
              className="inquiry-file-btn"
              onClick={onToggleAttachmentPopup}
              style={{height:"39px"}}
            >
              <MdAttachFile className="inquiry-file-icon" />{" "}
              {`${attachments.length}`}
            </span>
          )}
          {isAttachmentPopupOpen && (
            <div className="attach-popup-amc1">
              <div className="attach-popup-contant">
                <div className="attachment-header">
                  <div className="attachment-header-content">Attachments</div>
                  <button
                    type="button"
                    className="fiile-close-btn"
                    onClick={onCloseAttachmentPopup}
                  >
                    <IoCloseOutline className="file-close-icon" />
                  </button>
                </div>
                {attachments.length > 0 ? (
                  <div className="attach-scrroll-body">
                    {attachments.map((attachment, index) => (
                      <div className="attach-popup-contant-body" key={index}>
                        <div className="attach-file-container">
                          <div className="attach-file-show">
                            <div className="text-attachment">
                              {getMeetingAttachmentName(attachment)}
                            </div>
                            <div className="text-attachment-file">
                              File Size: (
                              {getMeetingAttachmentSizeLabel(attachment)})
                            </div>
                          </div>
                          <div
                            className="file-delete-btn"
                            onClick={() => onDeleteAttachment(index)}
                          >
                            <span>
                              <IoCloseOutline className="file-close-icon" />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="meeting-no-attachments">
                    No documents selected
                  </div>
                )}
              </div>
            </div>
          )}
          {errors.attachments && (
            <div className="error-message">{errors.attachments}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MeetingFormFields;
